import { Button } from "@mui/material";
import React from "react";

export const NavButton = ({ text, action, link }) => {
  return (
    <span className="header__link">
      <Button variant="contained" onClick={action} color="secondary">
        {link ?? text}
      </Button>
    </span>
  );
};
